export default __webpack_public_path__ + "static/twistbreak-d94e6617202fef1b3d7800b1fb320630.png";